export const API_BASE = process.env.OMNIPLATFORM_API;
export const COMPENSATION_API_BASE = process.env.COMPENSATION_API;

export const API_PATH = 'expenses';
export const API_CONFIG_PATH = 'config';
export const API_UPLOAD_PATH = 'upload';
